<router-outlet></router-outlet>
<div class="version"> {{appVersion}}</div>


